import React,{useState} from 'react';
import EmployAside from '../../aside';
import InformationGenerale from './info-generale';

const InfoGenerale = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className='main-page-wrapper'>
      
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <InformationGenerale setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default InfoGenerale;